"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = require("react");

var _propTypes = require("prop-types");

var _moment = _interopRequireDefault(require("moment"));

var _core = require("@material-ui/core");

var _ZipPayContractSummary = _interopRequireDefault(require("./ZipPayContractSummary"));

var _ZipPayTermsAndConditions = _interopRequireDefault(require("./ZipPayTermsAndConditions"));

var Buttons = _interopRequireWildcard(require("../../../components/input/button/Button"));

var Dialogs = _interopRequireWildcard(require("../../../components/surface/dialog/Dialog"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var defaultProps = {
  companyName: 'ZipMoney Payments Pty Ltd',
  businessNumber: 'ABN 58 164 440 993',
  companyWebsite: 'https://zip.co',
  companyPhone: '(02) 8294 2345',
  companyAddress: '14/10 Spring Street, Sydney, NSW, 2000, AU',
  companyEmail: 'hello@care.zip.co',
  disputeName: 'Australian Financial Complaints Authority (AFCA)',
  disputePhone: '1800 931 678',
  disputeMailbox: 'GPO Box 3, Melbourne, VIC, 3001',
  disputeWebsite: 'www.afca.org.au',
  acceptanceDate: (0, _moment["default"])().format('DD MMMM, YYYY')
};

var ZipPayContract = function ZipPayContract(props) {
  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      summaryOpen = _useState2[0],
      toggleView = _useState2[1];

  var theme = (0, _core.useTheme)();
  var isMobile = (0, _core.useMediaQuery)(theme.breakpoints.down('xs'));
  return summaryOpen ? (0, _jsxRuntime.jsx)(_ZipPayContractSummary["default"], _objectSpread({
    toggleView: toggleView
  }, props)) : (0, _jsxRuntime.jsx)(Dialogs.Basic, {
    actions: (0, _jsxRuntime.jsx)(Buttons.Primary, {
      onClick: function onClick() {
        return toggleView(true);
      },
      children: "Close"
    }),
    fullScreen: isMobile,
    open: !summaryOpen,
    onClose: function onClose() {
      return toggleView(true);
    },
    children: (0, _jsxRuntime.jsx)(_ZipPayTermsAndConditions["default"], _objectSpread({}, props))
  });
};

ZipPayContract.propTypes = {
  companyName: _propTypes.string,
  businessNumber: _propTypes.string,
  companyWebsite: _propTypes.string,
  companyPhone: _propTypes.string,
  companyAddress: _propTypes.string,
  companyEmail: _propTypes.string,
  customerName: _propTypes.string.isRequired,
  customerAddress: _propTypes.string.isRequired,
  customerEmail: _propTypes.string.isRequired,
  customerMobile: _propTypes.string.isRequired,
  accountLimit: _propTypes.string.isRequired,
  minimumMonthlyRepayment: _propTypes.string.isRequired,
  dueDate: _propTypes.string.isRequired,
  monthlyServiceFee: _propTypes.string.isRequired,
  latePaymentFee: _propTypes.string.isRequired,
  acceptanceDate: _propTypes.string,
  disputeName: _propTypes.string,
  disputeMailbox: _propTypes.string,
  disputePhone: _propTypes.string,
  disputeWebsite: _propTypes.string
};
ZipPayContract.defaultProps = defaultProps;
var _default = ZipPayContract;
exports["default"] = _default;